const state = {
	selectorInfo: {}
};
export default state;
